//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">cTrader账户绑定流程</div>
                  <p>
                      打开cTrader 交易软件并登录交易账号。
                  </p>
                  <p>
                      在策略列表中选中WikiFxDefense天眼盾脚本，进行如下操作：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
                  </p>
                  <p>
                      窗口中出现如下所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
                  </p>
                  <p>
                      然后点击绿色箭头即可
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
                  </p>
                  <p class="attention">
                      注：WikiFxDefense天眼盾脚本需持续加载。
                  </p>`,
        zh: `
        <div class="title-box">cTrader帳戶綁定流程</div>
              <p>
                  開啟cTrader 交易軟體並登入交易帳號。
              </p>
              <p>
                  在政策清單中選取WikiFxDefense天眼盾腳本，進行如下操作：
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  視窗中出現如下所示：
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  然後點擊綠色箭頭即可
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  註：WikiFxDefense天眼盾腳本需持續載入。
              </p>`,
        en: `
        <div class="title-box">cTrader account binding process</div>
              <p>
                  Open the cTrader trading software and log in to your trading account.
              </p>
              <p>
                  Select the WikiFxDefense Sky Eye Shield script in the strategy list and perform the following operations:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  The following appears in the window:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  Then click the green arrow
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  Note: The WikiFxDefense Sky Eye Shield script needs to be loaded continuously.
              </p>`,
        ru: `
        <div class="title-box">Процесс привязки учетной записи cTrader</div>
              <p>
                  Откройте торговое программное обеспечение cTrader и войдите в свой торговый счет.
              </p>
              <p>
                  В списке стратегий выберите скрипт WikiFxDefense Sky Eye Shield и выполните следующие операции:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  В окне появляется следующее:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  Затем нажмите зеленую стрелку
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  Примечание. Сценарий WikiFxDefense Sky Eye Shield необходимо загружать постоянно.
              </p>`,
        ja: `
        <div class="title-box">cTraderアカウントバインドプロセス</div>
              <p>
                  cTrader 取引ソフトウェアを開き、取引アカウントにログインします。
              </p>
              <p>
                  戦略リストで WikiFx Defense Sky Eye Shield スクリプトを選択し、次の操作を実行します。
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  ウィンドウに次の内容が表示されます。
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  次に、緑色の矢印をクリックします
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  注: WikiFx Defense Sky Eye Shield スクリプトは継続的にロードする必要があります。
              </p>`,
        th: `
        <div class="title-box">กระบวนการผูกบัญชี cTrader</div>
            <p>
                เปิดซอฟต์แวร์การซื้อขาย cTrader และเข้าสู่ระบบบัญชีซื้อขายของคุณ
            </p>
            <p>
                เลือกสคริปต์ WikiFxDefense Sky Eye Shield ในรายการกลยุทธ์และดำเนินการต่อไปนี้:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                สิ่งต่อไปนี้จะปรากฏขึ้นในหน้าต่าง:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                จากนั้นคลิกลูกศรสีเขียว
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                หมายเหตุ: จำเป็นต้องโหลดสคริปต์ WikiFxDefense Sky Eye Shield อย่างต่อเนื่อง
            </p>`,
        vi: `
        <div class="title-box">quy trình ràng buộc tài khoản cTrader</div>
            <p>
                Mở phần mềm giao dịch cTrader và đăng nhập vào tài khoản giao dịch của bạn.
            </p>
            <p>
                Chọn tập lệnh WikiFxDefense Sky Eye Shield trong danh sách chiến lược và thực hiện các thao tác sau:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                Thông tin sau xuất hiện trong cửa sổ:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                Sau đó bấm vào mũi tên màu xanh
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                Lưu ý: Tập lệnh WikiFxDefense Sky Eye Shield cần được tải liên tục.
            </p>`,
        id: `
        <div class="title-box">proses pengikatan akun cTrader</div>
            <p>
                Buka perangkat lunak perdagangan cTrader dan masuk ke akun perdagangan Anda.
            </p>
            <p>
                Pilih skrip WikiFxDefense Sky Eye Shield di daftar strategi dan lakukan operasi berikut:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                Berikut ini muncul di jendela:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                Kemudian klik panah hijau
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                Catatan: Skrip WikiFxDefense Sky Eye Shield perlu dimuat terus menerus.
            </p>`,
        es: `
        <div class="title-box">Proceso de vinculación de cuenta cTrader</div>
            <p>
                Abra el software comercial cTrader e inicie sesión en su cuenta comercial.
            </p>
            <p>
                Seleccione el script WikiFxDefense Sky Eye Shield en la lista de estrategias y realice las siguientes operaciones:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                En la ventana aparece lo siguiente:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                Luego haga clic en la flecha verde
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                Nota: El script WikiFxDefense Sky Eye Shield debe cargarse continuamente.
            </p>`,
        hi: `
        <div class="title-box">cTrader खाता बाइंडिंग प्रक्रिया</div>
              <p>
                  cTrader ट्रेडिंग सॉफ्टवेयर खोलें और अपने ट्रेडिंग खाते में लॉग इन करें।
              </p>
              <p>
                  रणनीति सूची में WikiFxDefense स्काई आई शील्ड स्क्रिप्ट का चयन करें और निम्नलिखित ऑपरेशन करें:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  निम्नलिखित विंडो में दिखाई देता है:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  फिर हरे तीर पर क्लिक करें
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  नोट: WikiFxDefense स्काई आई शील्ड स्क्रिप्ट को लगातार लोड करने की आवश्यकता है।
              </p>`,
        fil: `
        <div class="title-box">Proseso ng pagbubuklod ng cTrader account</div>
              <p>
                  Buksan ang cTrader trading software at mag-log in sa iyong trading account.
              </p>
              <p>
                  Piliin ang script ng WikiFxDefense Sky Eye Shield sa listahan ng diskarte at gawin ang mga sumusunod na operasyon:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  Ang sumusunod ay lilitaw sa window:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  Pagkatapos ay i-click ang berdeng arrow
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  Tandaan: Ang script ng WikiFxDefense Sky Eye Shield ay kailangang patuloy na i-load.
              </p>`,
        fr: `
        <div class="title-box">Processus de liaison de compte cTrader</div>
              <p>
                  Ouvrez le logiciel de trading cTrader et connectez-vous à votre compte de trading.
              </p>
              <p>
                  Sélectionnez le script WikiFxDefense Sky Eye Shield dans la liste des stratégies et effectuez les opérations suivantes :
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
              </p>
              <p>
                  Ce qui suit apparaît dans la fenêtre&nbsp;:
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
              </p>
              <p>
                  Cliquez ensuite sur la flèche verte
              </p>
              <p class="m24">
                <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
              </p>
              <p class="attention">
                  Remarque&nbsp;: Le script WikiFxDefense Sky Eye Shield doit être chargé en continu.
              </p>`,
        de: `
        <div class="title-box">cTrader-Kontobindungsprozess</div>
            <p>
                Öffnen Sie die Handelssoftware cTrader und melden Sie sich bei Ihrem Handelskonto an.
            </p>
            <p>
                Wählen Sie das WikiFxDefense Sky Eye Shield-Skript in der Strategieliste aus und führen Sie die folgenden Vorgänge aus:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                Im Fenster erscheint Folgendes:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                Klicken Sie dann auf den grünen Pfeil
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                Hinweis: Das WikiFxDefense Sky Eye Shield-Skript muss kontinuierlich geladen werden.
            </p>`,
        pt: `
        <div class="title-box">Processo de vinculação de conta cTrader</div>
            <p>
                Abra o software de negociação cTrader e faça login em sua conta de negociação.
            </p>
            <p>
                Selecione o script WikiFxDefense Sky Eye Shield na lista de estratégias e execute as seguintes operações:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                O seguinte aparece na janela:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                Em seguida, clique na seta verde
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                Nota: O script WikiFxDefense Sky Eye Shield precisa ser carregado continuamente.
            </p>`,
        tr: `
        <div class="title-box">cTrader hesap bağlama süreci</div>
            <p>
                cTrader ticaret yazılımını açın ve ticaret hesabınıza giriş yapın.
            </p>
            <p>
                Strateji listesinden WikiFxDefense Sky Eye Shield komut dosyasını seçin ve aşağıdaki işlemleri gerçekleştirin:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                Pencerede aşağıdakiler görünür:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                Daha sonra yeşil oka tıklayın
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                Not: WikiFxDefense Sky Eye Shield komut dosyasının sürekli olarak yüklenmesi gerekir.
            </p>`,
        ko: `
        <div class="title-box">cTrader 계정 바인딩 프로세스</div>
            <p>
                cTrader 거래 소프트웨어를 열고 거래 계좌에 로그인하세요.
            </p>
            <p>
                전략 목록에서 WikiFxDefense Sky Eye Shield 스크립트를 선택하고 다음 작업을 수행합니다.
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                창에 다음이 나타납니다.
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                그런 다음 녹색 화살표를 클릭하십시오.
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                참고: WikiFxDefense Sky Eye Shield 스크립트는 지속적으로 로드되어야 합니다.
            </p>`,
        ar: `
        <div class="title-box">عملية ربط حساب cTrader</div>
            <p>
                افتح برنامج التداول cTrader وقم بتسجيل الدخول إلى حساب التداول الخاص بك.
            </p>
            <p>
                حدد البرنامج النصي WikiFxDefense Sky Eye Shield في قائمة الإستراتيجية وقم بتنفيذ العمليات التالية:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon1.png')}"/>
            </p>
            <p>
                يظهر ما يلي في النافذة:
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon2.png')}"/>
            </p>
            <p>
                ثم انقر فوق السهم الأخضر
            </p>
            <p class="m24">
              <img src="${require('~/assets/img/help/cTrader-icon3.png')}"/>
            </p>
            <p class="attention">
                ملحوظة: يجب تحميل البرنامج النصي WikiFxDefense Sky Eye Shield بشكل مستمر.
            </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('40590'),
      meta: [
        { name: 'Description', content: this.$t('40595') }
      ]
    }
  }
}
